import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';
import { formatNumber } from 'utils/formatHelper';
import { Link, useNavigate } from 'react-router-dom';

import { DropdownRouting, ListDate, ListStatusProduct } from 'services/commonDate_services';
import { commonDatePresenter, commonDateStore, reportPresenter, reportStore } from 'stores/root_store';
import { ListKeynValue, WoQCProductionModel } from 'services/report_services';
import { SearchModel } from './model';

import { AiFillCaretDown, AiOutlineMinus } from 'react-icons/ai';
import { FaSearch } from 'react-icons/fa';
import { HiSearch } from 'react-icons/hi';
import { TbLoaderQuarter } from 'react-icons/tb';
import Pagination from 'base/ui/components/Pagination/pagination';
import { Autocomplete, TextField, Tooltip } from '@mui/material';
import LoadingScreen from 'base/ui/components/LoadingScreen/loadingScreen';
import { FaDownload } from 'react-icons/fa';

const Style = {
  '.MuiOutlinedInput-root': {
    padding: 0,
    borderRadius: 0,
    fontSize: '13px',
  },
  '.MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
    fontSize: '13px',
  },
  '.MuiAutocomplete-inputRoot .MuiAutocomplete-input[aria-controls]': {
    fontSize: '13px',
  },
};

export function checkStateMarketing() {
  return observer(() => {
    const column = [
      {
        columnName: 'STT',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'LSX',
        align: 'text-center',
        visible: true,
        key: 'workOrderCode',
      },
      {
        columnName: 'Mã SP',
        align: 'text-center',
        visible: true,
        key: 'productCode',
      },
      {
        columnName: 'Tên SP',
        align: 'text-center',
        visible: true,
        key: 'productName',
      },
      {
        columnName: 'STT Bước',
        align: 'text-center',
        visible: true,
        key: 'orderIndex',
      },

      {
        columnName: 'Công đoạn KT',
        align: 'text-center',
        visible: true,
        key: 'stepName',
      },
      {
        columnName: 'Số SP/Tờ/CĐ',
        align: 'text-center',
        visible: true,
        key: 'productPerPage',
      },
      {
        columnName: 'ĐVT công đoạn',
        align: 'text-center',
        visible: true,
        key: 'unit',
      },
      {
        columnName: 'SL sản xuất (Sản phẩm)',
        align: 'text-center',
        visible: true,
        key: 'orderQuantity',
      },
      {
        columnName: 'SL đạt giao hàng (Sản phẩm)',
        align: 'text-center',
        visible: true,
      },

      {
        columnName: 'SL đạt từng bước (Tờ, pcs)',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL đạt từng bước (pcs)',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL hư hỏng từng bước (Tờ, pcs)',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'SL hư hỏng từng bước (pcs)',
        align: 'text-center',
        visible: true,
      },
      {
        columnName: 'Tỉ lệ hao hụt trong CĐSX',
        align: 'text-center',
        visible: true,
      },
    ];
    const navigate = useNavigate();
    //========================================================================================================== //
    //-------------------------------------------      STATE     -------------------------------------------------//
    //========================================================================================================== //
    // Loading của cả trang nếu gửi api thì cho loading
    const [loading, setLoading] = useState(false);
    // mở from search
    const [openSearchBox, setOpenSearchBox] = useState(false);
    // data table
    const [listQCProduction, setListQCProduction] = useState<WoQCProductionModel[]>([]);
    // data dropdown routing
    const [listRouting, setListRouting] = useState<DropdownRouting[]>([]);
    // ======================= SEARCH ======================================
    // keyword dùng để lấy common product
    const [productKeyword, setProductKeyword] = useState<string>('');
    // Common date, list ngày
    const [listCommonDate, setListCommonDate] = useState<ListDate[]>([]);
    // autocomplete tp/btp
    const [dropdownProduct, setDropdownProduct] = useState<ListStatusProduct[]>([]);
    // Ngày ra LSX => Lưu key của common date để lấy ngày
    const [createTimeWO, setCreateTimeWO] = useState<string>('ThisWeek');
    // Ngày kiểm tra => Lưu key của common date để lấy ngày
    const [qcTime, setQCTime] = useState<string>('');
    // data tìm kiếm + phân trang + sort
    const [dataSearch, setDataSearch] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderByDesc: 'woCode',
        orderBy: '',
      },
      stepCode: '',
      woCode: '',
      productCode: '',
      resultQC: '',
      qcFromTime: null,
      qcToTime: null,
      createTimeWOFrom: null,
      createTimeWOTo: null,
    });
    // danh sách LSX
    const [dropdownWO, setDropdownWO] = useState<ListKeynValue[]>([]);
    // key word lsx
    const [lsxKeyword, setLsxKeyword] = useState('');
    // keyword routing
    const [keywordRouting, setKeywordRouting] = useState('');
    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //-------------------------------------     -GET DATA       -------------------------------------------------//
    //========================================================================================================== //

    //-----FUNCTION-------------------------------------------------------------------------------------------- //
    // Lấy danh sách common date
    const getListCommonDate = async () => {
      await commonDatePresenter.getListCommonDate(commonDateStore);
      setListCommonDate(commonDateStore.listDate.data);
    };

    // Lấy dropdown products
    const getDropdownProduct = async () => {
      await commonDatePresenter.getListDropdownProduct(commonDateStore, productKeyword);
      setDropdownProduct(commonDateStore.listDropdownProduct);
    };
    // Lấy data table
    const getDataTable = async (searchValue = dataSearch) => {
      await reportPresenter.getListQCProction(reportStore, searchValue);
      if (reportStore.qcProcductionResponse.isSuccess) {
        setListQCProduction(reportStore.qcProcductionResponse.data);
      }
    };
    // Lấy dropdown lệnh sản xuất
    const getDropdownLSX = async () => {
      await reportPresenter.getDropdownWo(reportStore, lsxKeyword);
      if (reportStore.listKeynValue.isSuccess) {
        setDropdownWO(reportStore.listKeynValue.data);
      }
    };

    // Lấy dropdown công đoạn
    const getDataDropdownRouting = async (dataSearch = keywordRouting) => {
      await commonDatePresenter.getDropdownRouting(commonDateStore, dataSearch);
      if (commonDateStore.dropdownRouting.isSuccess) {
        setListRouting(commonDateStore.dropdownRouting.data);
      }
    };
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //

    useEffect(() => {
      const getDate = async () => {
        if (createTimeWO) {
          await commonDatePresenter.getDataByCommonDate(commonDateStore, createTimeWO);
          setDataSearch({
            ...dataSearch,
            createTimeWOFrom: commonDateStore.commonDate.fromDate,
            createTimeWOTo: commonDateStore.commonDate.toDate,
          });
        } else {
          setDataSearch({
            ...dataSearch,
            createTimeWOFrom: null,
            createTimeWOTo: null,
          });
        }
      };
      // call ap khi mở trang
      const getData = async () => {
        await getListCommonDate();
        await getDate();
        await getDropdownProduct();
        await getDropdownLSX();
        await getDataDropdownRouting();
        await getDataTable({
          paging: {
            pageSize: PAGE_SIZE_DEFAULT,
            pageIndex: 1,
            orderByDesc: 'woCode',
            orderBy: '',
          },
          stepCode: '',
          woCode: '',
          productCode: '',
          resultQC: '',
          qcFromTime: null,
          qcToTime: null,
          createTimeWOFrom: commonDateStore.commonDate.fromDate,
          createTimeWOTo: commonDateStore.commonDate.toDate,
        });
        setLoading(false);
      };
      getData();
    }, []);

    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //--------------------------------------   PHÂN TRANG VÀ SẮP XẾP --------------------------------------------//
    //========================================================================================================== //

    //-----PHÂN TRANG-------------------------------------------------------------------------------------------- //
    const handleChangePageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
      setDataSearch({
        ...dataSearch,
        paging: { ...dataSearch.paging, pageSize: parseInt(e.target.value) },
      });
    };

    const handleChangePageIndex = (data: any) => {
      setDataSearch({
        ...dataSearch,
        paging: { ...dataSearch.paging, pageIndex: data.selected + 1 },
      });
    };

    useEffect(() => {
      // cho loading khi chuyển trang
      const pageIndexChange = async () => {
        setLoading(true);
        await getDataTable();
        setLoading(false);
      };
      pageIndexChange();
    }, [dataSearch.paging.pageIndex]);

    useEffect(() => {
      // cho loading khi thay đổi page size
      const pageSizeChange = async () => {
        setLoading(true);
        // Chuyển về trang 1
        setDataSearch({
          ...dataSearch,
          paging: { ...dataSearch.paging, pageIndex: 1 },
        });
        await getDataTable();
        setLoading(false);
      };
      pageSizeChange();
    }, [dataSearch.paging.pageSize]);
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //-----SẮP XẾP-------------------------------------------------------------------------------------------- //
    // Sort
    const handleSort = async (key: string) => {
      if (dataSearch.paging.orderBy === '' && dataSearch.paging.orderByDesc === '') {
        setDataSearch({
          ...dataSearch,
          paging: { ...dataSearch.paging, orderBy: key },
        });
        await getDataTable({
          ...dataSearch,
          paging: { ...dataSearch.paging, orderBy: key },
        });
      } else if (dataSearch.paging.orderBy === '') {
        setDataSearch({
          ...dataSearch,
          paging: { ...dataSearch.paging, orderBy: key, orderByDesc: '' },
        });
        await getDataTable({
          ...dataSearch,
          paging: { ...dataSearch.paging, orderBy: key, orderByDesc: '' },
        });
      } else if (dataSearch.paging.orderByDesc === '') {
        setDataSearch({
          ...dataSearch,
          paging: { ...dataSearch.paging, orderBy: '', orderByDesc: key },
        });
        await getDataTable({
          ...dataSearch,
          paging: { ...dataSearch.paging, orderBy: '', orderByDesc: key },
        });
      }
    };
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //-------------------------------------------COMMON HANDLE-------------------------------------------------//
    //========================================================================================================== //

    //-----COMMON DATE-------------------------------------------------------------------------------------------- //
    // xử lý lấy key common date
    const handleGetCommonDate = (e: React.SyntheticEvent<Element, Event>, value: ListDate | null, type: string) => {
      if (type === 'createTimeWO') {
        if (value) {
          setCreateTimeWO(value.key);
        } else {
          setCreateTimeWO('');
        }
      } else if (type === 'qcTime') {
        if (value) {
          setQCTime(value.key);
        } else {
          setQCTime('');
        }
      }
    };

    useEffect(() => {
      const getDate = async () => {
        if (createTimeWO) {
          await commonDatePresenter.getDataByCommonDate(commonDateStore, createTimeWO);
          setDataSearch({
            ...dataSearch,
            createTimeWOFrom: commonDateStore.commonDate.fromDate,
            createTimeWOTo: commonDateStore.commonDate.toDate,
          });
        } else {
          setDataSearch({
            ...dataSearch,
            createTimeWOFrom: null,
            createTimeWOTo: null,
          });
        }
      };
      getDate();
    }, [createTimeWO]);

    useEffect(() => {
      const getDate = async () => {
        if (qcTime) {
          await commonDatePresenter.getDataByCommonDate(commonDateStore, qcTime);
          setDataSearch({
            ...dataSearch,
            qcFromTime: commonDateStore.commonDate.fromDate,
            qcToTime: commonDateStore.commonDate.toDate,
          });
        } else {
          setDataSearch({
            ...dataSearch,
            qcFromTime: null,
            qcToTime: null,
          });
        }
      };
      getDate();
    }, [qcTime]);

    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //

    //-----COMMON PRODUCT-------------------------------------------------------------------------------------------- //
    // gọi get dropdown product khi key word thay đổi
    useEffect(() => {
      getDropdownProduct();
    }, [productKeyword]);

    // Lưu product code vào state search khi chọn / nếu không chọn thì set chuỗi rỗng
    const handleChangeProductCode = (e: React.SyntheticEvent<Element, Event>, value: ListStatusProduct | null) => {
      if (value) {
        setDataSearch({ ...dataSearch, productCode: value.key });
      } else {
        setDataSearch({ ...dataSearch, productCode: '' });
      }
    };
    // lưu keyword product để call api
    const handleChangeKeyWordProductCode = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setProductKeyword(e.target.value);
    };
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //-----COMMON LSX-------------------------------------------------------------------------------------------- //
    const handleChangeWOCode = (e: React.SyntheticEvent<Element, Event>, value: ListKeynValue | null) => {
      if (value) {
        setDataSearch({ ...dataSearch, woCode: value.key });
      } else {
        setDataSearch({ ...dataSearch, woCode: '' });
      }
    };
    // lưu keyword wo để call api
    const handleChangeKeyWordWOCode = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setLsxKeyword(e.target.value);
    };
    // gọi get dropdown wo khi key word thay đổi
    useEffect(() => {
      getDropdownLSX();
    }, [lsxKeyword]);
    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //-----COMMON STEP-------------------------------------------------------------------------------------------- //
    const handleChangeStepCode = (e: React.SyntheticEvent<Element, Event>, value: DropdownRouting | null) => {
      if (value) {
        setDataSearch({ ...dataSearch, stepCode: value.stepCode });
      } else {
        setDataSearch({ ...dataSearch, stepCode: '' });
      }
    };
    // lưu keyword wo để call api
    const handleChangeKeyWordStepCode = async (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setKeywordRouting(e.target.value);
      await getDataDropdownRouting(e.target.value);
    };

    //------------------------xxx-----------------------xxx-------------------------xxx------------------------- //
    //=======================XXX========================XXX=========================XXX========================= //

    //========================================================================================================== //
    //-------------------------------------------XỬ LÝ TÌM KIẾM-------------------------------------------------//
    //========================================================================================================== //
    const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
      setDataSearch({
        ...dataSearch,
        [e.target.id]:
          e.target.id === 'qcFromTime' ||
            e.target.id === 'qcToTime' ||
            e.target.id === 'createTimeWOFrom' ||
            e.target.id === 'createTimeWOTo'
            ? e.target.value
              ? e.target.value
              : null
            : e.target.value,
      });
    };
    // Tìm kiếm
    const handleSearch = async () => {
      setLoading(true);
      await getDataTable();
      setLoading(false);
    };

    const handleExportExcel = async () => {
      setLoading(true);
      await reportPresenter.exportExcelBC11();
      setLoading(false);
    };

    //=======================XXX========================XXX=========================XXX========================= //

    return (
      <div className="w-full py-3 px-5">
        {loading && <LoadingScreen />}
        <div className="header">
          <div className="flex ">
            <div className="text-center flex-1">
              <h2 className="text-md font-bold text-gray-800 mb-2 uppercase">
                {' '}
                BC11. BÁO CÁO KIỂM TRA CÔNG ĐOẠN PHÒNG QC
              </h2>
              <div className="text-right absolute right-16 top-16 cursor-default">
                <div
                  onClick={() => handleExportExcel()}
                  className="flex items-center justify-center bg-success text-white rounded text-default px-2.5 pt-[0.25rem] pb-[0.3rem] text-center focus:outline-none hover:bg-success_hover"
                >
                  <FaDownload color="white" className="text-[15px] mr-1" /> Export excel
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="searchZone mt-2">
          {/* Form nhập tìm kiếm */}
          <div className={`relative ${openSearchBox ? 'border' : ''} border-neutral-300 mb-2 rounded`}>
            <div
              onClick={() => setOpenSearchBox(!openSearchBox)}
              className="absolute bg-primary w-6 h-6 rounded flex justify-center items-center top-[-36px] right-0 hover:bg-primary/80"
            >
              <AiOutlineMinus
                className={`text-white ${openSearchBox ? 'block' : 'hidden'} duration-700 text-default`}
              />
              <FaSearch className={`text-white ${openSearchBox ? 'hidden' : 'block'} duration-700 text-default`} />
            </div>
            <div
              className={`w-full bg-white flex overflow-hidden ${openSearchBox ? 'opacity-100' : ' opacity-0 h-0'
                } duration-700`}
            >
              <form className="w-full p-3.5 lg:grid lg:grid-cols-2 flex flex-col gap-2">
                {/* Lệnh SX */}
                <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
                  <label htmlFor="woCode" className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">
                    Lệnh SX
                  </label>
                  {/* <input
                    id="woCode"
                    onChange={handleChangeSearchValue}
                    className="col-span-2 text-gray-700 border border-border_input sm:ml-5 p-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                  /> */}
                  <Autocomplete
                    className="col-span-2 text-gray-700 text-default hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:ml-5 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    id="lsx"
                    options={dropdownWO}
                    onChange={handleChangeWOCode}
                    sx={Style}
                    classes={{
                      listbox: 'text-default',
                      input: '!text-gray-700',
                      noOptions: 'text-default',
                    }}
                    filterOptions={(options, state) => options}
                    getOptionLabel={(option) => option.value}
                    renderInput={(params) => <TextField onChange={handleChangeKeyWordWOCode} {...params} />}
                  />
                </div>
                {/* TP/BTP */}
                <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
                  <label
                    htmlFor="productCode"
                    className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end"
                  >
                    TP/BTP
                  </label>
                  <Autocomplete
                    className="col-span-2 text-gray-700 text-default hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:ml-5 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    id="productCode"
                    options={dropdownProduct}
                    onChange={handleChangeProductCode}
                    sx={Style}
                    classes={{
                      listbox: 'text-default',
                      input: '!text-gray-700',
                      noOptions: 'text-default',
                    }}
                    filterOptions={(options, state) => options}
                    getOptionLabel={(option) => option.value}
                    renderInput={(params) => <TextField onChange={handleChangeKeyWordProductCode} {...params} />}
                  />
                </div>

                {/* Công đoạn */}
                <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
                  <label htmlFor="stepCode" className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end">
                    Công đoạn
                  </label>
                  <Autocomplete
                    className="col-span-2 text-gray-700 text-default hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:ml-5 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    id="stepCode"
                    options={listRouting}
                    onChange={handleChangeStepCode}
                    sx={Style}
                    classes={{
                      listbox: 'text-default',
                      input: '!text-gray-700',
                      noOptions: 'text-default',
                    }}
                    filterOptions={(options, state) => options}
                    getOptionLabel={(option) => option.stepName}
                    renderInput={(params) => <TextField onChange={handleChangeKeyWordStepCode} {...params} />}
                  />
                </div>
                <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1"></div>
                {/* Ngày phát lệnh */}
                <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
                  <label
                    htmlFor="createTimeWO"
                    className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end"
                  >
                    Ngày phát lệnh
                  </label>
                  <Autocomplete
                    className="col-span-2 text-gray-700 text-default hover:ring-0 hover:outline-none hover:border-border_input !rounded-none border-border_input sm:ml-5 focus-visible:outline-none focus:border-blue-500 caret-blue-600"
                    id="createTimeWO"
                    defaultValue={{
                      key: 'ThisWeek',
                      value: 'ThisWeek | Tuần này',
                    }}
                    options={listCommonDate}
                    onChange={(e, value) => handleGetCommonDate(e, value, 'createTimeWO')}
                    sx={Style}
                    classes={{
                      listbox: 'text-default',
                      input: '!text-gray-700',
                      noOptions: 'text-default',
                    }}
                    getOptionLabel={(option) => option.value}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </div>
                <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1"></div>
                {/* từ ngày */}
                <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
                  <label
                    htmlFor="createTimeWOFrom"
                    className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end"
                  >
                    Từ ngày
                  </label>
                  <input
                    type="date"
                    id="createTimeWOFrom"
                    disabled={createTimeWO !== 'Custom' && createTimeWO !== ''}
                    value={dataSearch.createTimeWOFrom || ''}
                    onChange={handleChangeSearchValue}
                    className="col-span-2 text-gray-700 border border-border_input sm:ml-5 p-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 disabled:bg-white"
                  />
                </div>
                {/* đến ngày */}
                <div className="w-full sm:flex-row sm:items-center grid sm:grid-cols-3 grid-cols-1">
                  <label
                    htmlFor="createTimeWOTo"
                    className="min-w-[150px] font-bold text-default text-gray-700 sm:text-end"
                  >
                    Đến ngày
                  </label>
                  <input
                    type="date"
                    id="createTimeWOTo"
                    disabled={createTimeWO !== 'Custom' && createTimeWO !== ''}
                    value={dataSearch.createTimeWOTo || ''}
                    onChange={handleChangeSearchValue}
                    className="col-span-2 text-gray-700 border border-border_input sm:ml-5 p-1.5 text-default flex-1 focus-visible:outline-none focus:border-blue-500 caret-blue-600 disabled:bg-white"
                  />
                </div>
                {/* button tìm kiếm */}
                <div className="w-full flex justify-center col-span-2">
                  <button
                    type="button"
                    onClick={handleSearch}
                    className={`flex items-center text-white bg-blue-700 rounded text-default px-2.5 py-1 text-center focus:outline-none hover:bg-blue-600 

                  `}
                  >
                    {loading ? (
                      <>
                        <TbLoaderQuarter className="animate-spin bg" />
                        Loading...
                      </>
                    ) : (
                      <>
                        <HiSearch className="font-bold text-lg" />
                        Tìm kiếm
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* table main */}
        <div className="main zone">
          <div className="w-full bg-white p-3.5 rounded border border-neutral-300">
            {/*=========== Pagination =======================*/}
            <Pagination
              pageCount={reportStore.qcProcductionResponse.pagesCount}
              forcePage={dataSearch.paging.pageIndex - 1}
              onPageSizeChange={handleChangePageSize}
              onPageChange={handleChangePageIndex}
            />
            <div className="tableZOne">
              <div className={`overflow-x-auto overflow-y-auto max-h-[500px]`}>
                <table className="w-full text-default table-auto break-all border-collapse space-collapse my-3.5">
                  <thead className=" text-white bg-[#4682B4] !sticky !top-0">
                    <tr>
                      {column?.map((item, index) => {
                        if (item.visible) {
                          return (
                            <th
                              key={index}
                              scope="col"
                              onClick={() => (item.key ? handleSort(item.key) : null)}
                              className={`${item.visible ? '' : 'hidden'} py-2 px-2 border text-left ${item.align
                                } break-normal font-medium text-default min-w-[100px]`}
                            >
                              <div className={`flex w-full justify-center items-center`}>
                                <span>{item.columnName}</span>
                                {item.key && (
                                  <AiFillCaretDown
                                    className={`text-default min-w-[13px] ml-2 ${dataSearch.paging.orderBy === item.key ? '' : 'rotate-180'
                                      } duration-100`}
                                  />
                                )}
                              </div>
                              {/* {item.columnName} */}
                            </th>
                          );
                        }
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {listQCProduction.length ? (
                      listQCProduction.map((row, index) => (
                        <tr
                          key={index}
                          className={`break-normal ${row.isLast ? 'bg-[#ADE498] hover:bg[#ADE498]/80' : 'hover:bg-gray-100'
                            }`}
                        >
                          {/* Số thứ tự */}
                          <td className="whitespace-nowrap border p-1.5 text-center">{row.stt}</td>
                          {/* lệnh sản xuất */}
                          <td className="whitespace-nowrap border p-1.5 text-center">{row.workOrderCode}</td>
                          {/* mã sp */}
                          <td className="whitespace-nowrap border p-1.5">{row.productCode}</td>
                          {/* tên sp */}
                          <td className="whitespace-nowrap border p-1.5 !max-w-[200px] truncate cursor-default">
                            <Tooltip title={`${row.productName}`}>
                              <span>{row.productName}</span>
                            </Tooltip>
                          </td>
                          {/* STT bước */}
                          <td className="whitespace-nowrap border p-1.5 text-right">
                            {formatNumber(row.orderIndex, 0)}
                          </td>
                          {/* Công đoạn kiểm tra */}
                          <td className="whitespace-nowrap border p-1.5 font-medium cursor-pointer text-report_header hover:text-blue-500">
                            <Link
                              target={'_blank'}
                              to={`Detail/WorkOrderCode=${row.workOrderCode}&StepCode=${row.stepCode}`}
                            >
                              {row.stepName}
                            </Link>
                          </td>
                          {/* Số sp/tờ/công đoạn */}
                          <td className="whitespace-nowrap border p-1.5 text-right">
                            {formatNumber(row.productPerPage, 0)}
                          </td>
                          {/* đơn vị tính */}
                          <td className="whitespace-nowrap border p-1.5">{row.unit}</td>
                          {/* Số lượng sản xuất */}
                          <td className="whitespace-nowrap border p-1.5 text-right">
                            {formatNumber(row.orderQuantity, 0)}
                          </td>
                          {/* Số lượng đạt giao hàng */}
                          <td className="whitespace-nowrap border p-1.5 text-right">
                            {formatNumber(row.quantityOKDelivery, 0)}
                          </td>

                          {/* Số lượng đạt từng bước (Tờ / pcs) */}
                          <td className="whitespace-nowrap border p-1.5 text-right">
                            {formatNumber(row.quantityOKByStep1, 0)}
                          </td>
                          {/* Số lượng đạt từng bước (pcs) */}
                          <td className="whitespace-nowrap border p-1.5 text-right">
                            {formatNumber(row.quantityOKByStep2, 0)}
                          </td>
                          {/* Số lượng hư từng bước (Tờ /pcs) */}
                          <td className="whitespace-nowrap border p-1.5 text-right">
                            {formatNumber(row.quantityNotOKByStep1, 0)}
                          </td>
                          {/* Số lượng hư từng bước (pcs) */}
                          <td className="whitespace-nowrap border p-1.5 text-right">
                            {formatNumber(row.quantityNotOKByStep2, 0)}
                          </td>
                          {/* tỉ lệ hao hụt */}
                          <td className="whitespace-nowrap border p-1.5 text-right">
                            {row.percentLoss && row.percentLoss + '%'}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td className="border whitespace-nowrap px-2 py-1 text-center" colSpan={12}>
                          Không tìm thấy dữ liệu
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <span className="block text-default">
              Đang xem từ {`${listQCProduction && listQCProduction.length ? listQCProduction[0]?.stt : 0}`} đến {`${listQCProduction && listQCProduction.length ? listQCProduction[listQCProduction.length - 1]?.stt : 0}`} trong tổng số{' '}
              {reportStore.qcProcductionResponse.recordsTotal || 0} mục
            </span>
          </div>
        </div>
      </div>
    );
  });
}
